// Change this single constant to rename the internal test route prefix.
export const TEST_ROUTE_BASE = 'test';

export function withTestPrefix(path: string, testModeActive: boolean): string {
    if (!testModeActive) {
        return path;
    }
    return path === '/' ? `/${TEST_ROUTE_BASE}` : `/${TEST_ROUTE_BASE}${path}`;
}

export function isTestPath(pathname: string): boolean {
    const prefix = `/${TEST_ROUTE_BASE}`;
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function stripTestPrefix(pathname: string): string {
    const prefix = `/${TEST_ROUTE_BASE}`;
    if (pathname === prefix) {
        return '/';
    }
    if (pathname.startsWith(`${prefix}/`)) {
        return pathname.slice(prefix.length);
    }
    return pathname;
}
